import Loader from '@/shared-components/loader/Loader';
import Text from '@/shared-components/text/components/Text';

const NOOP = () => {};

export default function RandomizedHomeLinksList({
  className,
  randomizedState,
  emptyText,
  VirtualListComponent,
  virtualListProps = {},
  emptyTextClassName,
  children = null,
}) {
  if (!VirtualListComponent) {
    return null;
  }

  return (
    <div className={className}>
      {children}
      {randomizedState.loading ? (
        <Loader />
      ) : randomizedState.data.length === 0 ? (
        <Text className={emptyTextClassName} paragraph>
          {randomizedState.error || emptyText}
        </Text>
      ) : (
        <VirtualListComponent
          items={{
            data: randomizedState.data,
            totalDocs: randomizedState.data.length,
          }}
          onLoadMore={NOOP}
          {...virtualListProps}
        />
      )}
    </div>
  );
}
